// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"744":"3438c4aa","801":"c77bf63a"}[chunkId] + ".chunk.js";
};